import React, {FC} from 'react';

import Skeleton from 'coreComponents/Skeleton';

type TLoaderComponentProps = {};

const LoaderComponent : FC<TLoaderComponentProps> = () => {
	return <Skeleton height="100vh" width="100%" />;
};

export default LoaderComponent;